// MOCK authentication provider — PHASE A / DEVELOPMENT ONLY.
//
// There are no passwords, secrets or user accounts here. Anyone using this
// build can sign in as a learner, or deliberately enter ADMIN / DEVELOPMENT
// TEST MODE by acknowledging that it is a test mode. It provides NO security.
//
// Provider contract (implemented again by httpAuthProvider.js):
//   login(credentials)  → Promise<{ user, token }>   throws AuthError on failure
//   logout(session)     → Promise<void>
//   validate(session)   → Promise<boolean>           is the session still accepted?
import { ROLES } from './session.js';

export class AuthError extends Error {
  constructor(code, message) { super(message); this.code = code; }
}

const slug = (s) => String(s).trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'user';
const randomToken = () => {
  const b = new Uint8Array(16);
  (globalThis.crypto || { getRandomValues: (a) => a.map(() => Math.floor(Math.random() * 256)) }).getRandomValues(b);
  return `mock.${[...b].map((x) => x.toString(16).padStart(2, '0')).join('')}`;
};

export const mockAuthProvider = {
  name: 'mock',
  developmentOnly: true,
  /**
   * @param {{ username: string, role?: 'learner'|'admin', acknowledgeTestMode?: boolean }} c
   */
  async login({ username, role = ROLES.LEARNER, acknowledgeTestMode = false } = {}) {
    const name = String(username || '').trim();
    if (!name) throw new AuthError('invalid', 'Enter a name to sign in.');
    if (name.length > 40) throw new AuthError('invalid', 'Names are limited to 40 characters.');
    if (role !== ROLES.LEARNER && role !== ROLES.ADMIN) throw new AuthError('invalid', 'Unknown role.');
    if (role === ROLES.ADMIN && acknowledgeTestMode !== true) {
      throw new AuthError('ack', 'Confirm that you are entering a development test mode.');
    }
    return { user: { id: `${role}:${slug(name)}`, name, role }, token: randomToken() };
  },
  async logout() {},
  async validate(session) { return !!session?.token?.startsWith('mock.'); },
};
